import { Component, ComponentFactoryResolver, ComponentRef, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import swal from 'sweetalert2';
import { LabcoreEmailFile } from '../../../../shared/models/labcore-email-file.model';
import { LabcoreOrder } from '../../../../shared/models/labcore-order.model';
import { LaboratoryTestsService } from '../../../../shared/services/laboratory-tests.service';
import { SessionService } from '../../../../shared/services/session.service';
import { InputEmailComponent } from "./input-email/input-email.component";

@Component({
  selector: 'app-modal-send-email',
  templateUrl: './modal-send-email.component.html',
  styleUrls: ['./modal-send-email.component.css']
})
export class ModalSendEmailComponent implements OnInit {

  @ViewChild('modalSendEmail') modalSendEmail: TemplateRef<any>;

  @ViewChild('vc', {read: ViewContainerRef}) vc: ViewContainerRef;

  @ViewChild("childInputContainerRef", { read: ViewContainerRef })
  childInputContainerRef: ViewContainerRef;

  componentsReferences = Array<ComponentRef<InputEmailComponent>>();

  childInputIndex: number = 0;

  public showSpinnerLoading: boolean;

  public labcoreEmailFile: LabcoreEmailFile = new LabcoreEmailFile();

  public order: LabcoreOrder = new LabcoreOrder();

  public emailUser: string;

  public inputsEmailCC: any[] = [];

  public modalBodyHeight: number = 200;

  public regexEmail = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');

  public sendToEmailUser: boolean = false;

  public sendToOthers: boolean = false;


  constructor(
    private _sessionService: SessionService,
    private _laboratoryTestsService: LaboratoryTestsService,
    private componentFactoryResolver: ComponentFactoryResolver) { }


  ngOnInit() {
  }


  showDialog(order: LabcoreOrder) {
    this.order = order;
    this.emailUser = this._sessionService.getCurrentUser().email;

    if(this.emailUser != null) {
      this.sendToEmailUser = true;
    }

    let view = this.modalSendEmail.createEmbeddedView(null);
    this.vc.insert(view);
    this.modalSendEmail.elementRef.nativeElement.previousElementSibling.classList.remove('fade');
    this.modalSendEmail.elementRef.nativeElement.previousElementSibling.classList.add('modal-open'); 
    this.modalSendEmail.elementRef.nativeElement.previousElementSibling.style.display = 'block';
  }


  public sendToEmailUserChecked(event) {
    this.sendToEmailUser = event.target.checked;
  }


  public sendToOthersChecked(event) {
    this.sendToOthers = event.target.checked;

    // Elimina todos los inputs creados al quitar el check de enviar a otros correos.
    // También al cerrar el modal.
    if(!this.sendToOthers) {
      this.deleteAllInputsCC();
    }
  }


  public addInputEmailCC() {
    this.modalBodyHeight = this.modalBodyHeight + 60;

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(InputEmailComponent);
    const childComponentRef = this.childInputContainerRef.createComponent(componentFactory);

    let childComponent = childComponentRef.instance;
    childComponent.childInputIndex = ++this.childInputIndex;
    childComponent.parentRef = this;

    this.componentsReferences.push(childComponentRef);
  }


  public deleteInputEmailCC(index: number) {   
    if (this.childInputContainerRef.length < 1) return;

    const componentRef = this.componentsReferences.find((x) => x.instance.childInputIndex == index);
    const inputContainerRefIndex = this.childInputContainerRef.indexOf(componentRef as any);

    this.childInputContainerRef.remove(inputContainerRefIndex);

    this.componentsReferences = this.componentsReferences.filter(x => x.instance.childInputIndex !== index);

    this.modalBodyHeight = this.modalBodyHeight - 60;
  }


  public deleteAllInputsCC() {
    // Se obtienen los indices de cada elemento de this.componentsReferences
    let componentsReferencesLength = this.componentsReferences.map(c => c.instance.childInputIndex);
    
    for(let i of componentsReferencesLength) {
      this.deleteInputEmailCC(i);
    }
    
  }


  public emailDataValidation(orderNumber: string, fileStringBase64: string): boolean {
    
    this.inputsEmailCC = [];
    this.labcoreEmailFile.emailsCC = [];

    this.componentsReferences.forEach((x) => {
      if(x.instance.inputEmailCC != undefined && x.instance.inputEmailCC != null && x.instance.inputEmailCC != '') {
        this.inputsEmailCC.push(x.instance.inputEmailCC);
      }
    });

    this.labcoreEmailFile.nombreUsuario = this._sessionService.getCurrentUser().name;
    this.labcoreEmailFile.numeroOrden = orderNumber;
    this.labcoreEmailFile.archivoStringBase64 = fileStringBase64;


    if(!this.sendToEmailUser && (this.inputsEmailCC == undefined || this.inputsEmailCC.length == 0)) {
      this.showSwalPrepareEmailError("Debe ingresar un correo válido para enviar el archivo adjunto.");
      return false;
    }

    if(this.emailUser == null && this.inputsEmailCC == undefined) {
      this.showSwalPrepareEmailError("Debe ingresar un correo válido para enviar el archivo adjunto.");
      return false;
    }
    

    if(this.sendToEmailUser) {
      if(!this.regexEmail.test(this.emailUser)) {
        this.showSwalPrepareEmailError("Debe ingresar un correo válido para enviar el archivo adjunto.");
        return false;
      }
      
      this.labcoreEmailFile.emailUsuario = this.emailUser;
    }
    // Validación de correo de usuario.
    // Si el usuario no desea enviar el archivo a su correo registrado
    // se enviara al primer correo que ingreso en la segunda opción
    else {
      if(this.inputsEmailCC != undefined && this.inputsEmailCC.length > 0) {
        if(!this.regexEmail.test(this.inputsEmailCC[0])) {     
          this.showSwalPrepareEmailError("Uno de los correos ingresados no es válido.");
          return false;
        }
       
        this.labcoreEmailFile.emailUsuario = this.inputsEmailCC[0];
      }  
    }

    // Validación de correos CC
    if(this.inputsEmailCC != undefined && this.inputsEmailCC.length > 0) {
      for(var i = 0; i < this.inputsEmailCC.length; i++) {
        if(!this.regexEmail.test(this.inputsEmailCC[i])) {
          this.showSwalPrepareEmailError("Uno de los correos ingresados no es válido.");
          this.labcoreEmailFile.emailsCC = [];
          return false;   
        }
       
        this.labcoreEmailFile.emailsCC[i] = this.inputsEmailCC[i];
      }
    }
    else {
      this.labcoreEmailFile.emailsCC = [];
    }
    
    return true;
  }


  public sendEmailOfOrderPDF(orderNumber: string, fileStringBase64: string) {  
    this.showSpinnerLoading = true;

    var emailDataValidation = this.emailDataValidation(orderNumber, fileStringBase64);

    if(emailDataValidation) {
      this._laboratoryTestsService.sendEmailOfOrderPDF(this.labcoreEmailFile).subscribe(
        res => {
          this.showSpinnerLoading = false;
          this.showSwalSendEmailSuccess();
          this.closeDialog();
        },
        err => {
          this.showSpinnerLoading = false;
          this.showSwalSendEmailError(err.error.message);
        }
      );
    }
    else {
      this.showSpinnerLoading = false;
    }
  }


  public showSwalPrepareEmailError(message: string) {
    swal({
      title: 'Error',
      html: '<p style="font-size:14px"> ' + message + '</p>',
      type: 'warning',
      confirmButtonClass: 'btn btn-primary',
      buttonsStyling: false,
      focusConfirm: false
    });
    return;
  }


  public showSwalSendEmailSuccess() {
    swal({
      title: 'Exámenes laboratorio',
      html: '<p style="font-size:14px">El archivo adjunto ha sido enviado.</p>',
      type: 'success',
      confirmButtonClass: 'btn btn-primary',
      buttonsStyling: false,
      focusConfirm: false
    });
    return;
  }


  public showSwalSendEmailError(message: string) {
    swal({
      title: 'Error',
      html: '<p style="font-size:14px"> ' + message + '</p>',
      type: 'warning',
      confirmButtonClass: 'btn btn-primary',
      buttonsStyling: false,
      focusConfirm: false
    });
    return;
  }


  closeDialog() {
    this.vc.clear(); 
    this.deleteAllInputsCC();
    this.sendToOthers = false;
  }

}



// WEBPACK FOOTER //
// /app/src/app/office/laboratory-tests/modals/modal-send-email/modal-send-email.component.ts